import { FieldErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { CompanyBranchValidationSchema } from "../../schemas/createBranch.schema";
import TextField from "@/common/components/TextField";
import { removeSpecialCharacters } from "@/common/utils/unFormatters";
import { FormEvent } from "react";

interface CardConfigurationProps {
  register: UseFormRegister<CompanyBranchValidationSchema>;
  setValue: UseFormSetValue<CompanyBranchValidationSchema>;
  errors: FieldErrors<CompanyBranchValidationSchema>;
}

const CardConfiguration = ({ register, setValue, errors }: CardConfigurationProps) => {
  const handleChange = (event: FormEvent<HTMLInputElement>) => {
    let value = event.currentTarget.value;

    value = removeSpecialCharacters(value, { includeSpaces: true });

    setValue('name_on_card', value);
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-lg">
        Configurações do cartão
      </p>

      <div className="flex flex-col gap-2">
        <TextField
          label="Nome que será impresso no cartão"
          {...register('name_on_card')}
          onChange={handleChange}
          valueClassName="uppercase"
          errorMessage={errors.name_on_card?.message || undefined}
        />
      </div>
    </div>
  );
}

export default CardConfiguration;
